var map;
var token;
var marker;
var markers = [];
var _collection_icons=["https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Seiko5_Black.png?v=1661411997","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/pressage_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/prospex_logo_black.svg?582","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215","https://cdn.shopify.com/s/files/1/0019/1184/9012/files/Screenshot_2024-04-23_at_6.19.35_AM.png?v=1713835215"];
var _allstores_list=[];
var _curr_lat=0;
var _curr_lng=0;

function GetCollectionIcons(_collections) {
  var _res="";
  if(_collections.length>0){
    _collections.map(function(_i){
        if(_i == 1){
          var hh = 32;
        }
        else{
          var hh = 14;
        }
        _res+='<img src="'+_collection_icons[_i]+'" style="padding-top:0px;width:auto;height:'+hh+'px;display:inline-block;margin:5px 12px" />'; 
    });
  } 
  return _res; 
}

function getDistance(lat1,lon1,lat2,lon2) {
  lon2 = Number(lon2.toString().replace(/,/g, ''));
  var R = 3963.1676; // Radius of the earth in miles
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lon2-lon1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in miles
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI/180)
}

function LoaderShow() {
  $('.map_loader').show();
  $('.l_map_wrap_m').hide();
  $('.l_map_wrap_modal').css({'visibility':'visible','opacity':'1'});
}

function LoaderHide() {
  $('.map_loader').hide();	
  $('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
}

function PopuperShow(test) {
  $('#l_map_wrap_m_text').animate({ opacity: 0, height: 0 }, 300, function(){
    if(window.innerWidth > 640){
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '90px' }, 600);	
    }
    else{
    	$('#l_map_wrap_m_text').html(test).animate({ opacity: 1, height: '60px' }, 600);	
    }
  });
}

function L_GeoIP(){
	    $.getJSON("https://geoip-db.com/json/").success(function(data) {
        	if(data.country_code!="US"){
              	LoaderShow();
              	searchLocationsNear(40.7394322, -73.9988017, function(){
              		PopuperShow("No locations were found using your search criteria [ <b>"+(data.country_name || 'Your location')+"</b> ]. Please try another input address to search for locations.");
				});
			} else{
				searchLocationsNear(parseFloat(data.latitude),parseFloat(data.longitude));
			}
        }).error(function() {
          	  LoaderShow();
              searchLocationsNear(40.7394322, -73.9988017, function(){
                  PopuperShow("No locations were found using your search criteria [Your location]. Please try another input address to search for locations."); 
              });
        });
}

function L_GeoIPFirstOpen(){
  LoaderShow();
  clearLocations();
  markers = [];

  map.setView([41.07948863511428, -74.16179180145265], 13);
 
  var id = "5d13c0f07e64391100b2090c";
  var store_name = "Seiko Corporation of America";
  var phone = "+1 201-529-5730";
  var site = "seikousa.com";
  var address = "1111 MacArthur Blvd, Mahwah, NJ 07430, USA";
  var latl = "41.07948863511428";
  var lngl = "-74.16179180145265";
  var _collections="";
  var distance = getDistance(41.07948863511428, -74.16179180145265, latl, lngl).toFixed(1);

  createMarker(id, store_name, phone, address, latl, lngl, 0, distance, site, _collections);
  
  LoaderHide();
  centerMarkers();
}

function clearLocations() {
	$(".l_map_res_list").empty();
    markers.map(function(_i){
       map.removeLayer(_i);
    });
}

function searchLocations() {
	var address =($('#praddress').val().length>0 ? $('#praddress').val().trim().replace(/ /g,'+')+'+' : "");
	
	if(address.length>2){
		$.getJSON('https://geocode.maps.co/search?q='+address+'&api_key=658c72e030653798329319cwx861442', function(_locs) {    
		if (_locs) {
			if (_locs[0]) {
				searchLocationsNear(parseFloat(_locs[0].lat),parseFloat(_locs[0].lon));
			} else {
              	LoaderShow();
				PopuperShow("No locations were found using address.");
			}
		} else {
          	LoaderShow();	
			PopuperShow("No locations were found using address.");
		}
		});
	}else{
      	LoaderShow();	
		PopuperShow("Please enter an address.");
	}
	return false;
}

function centerMarkers() {
	var group = L.featureGroup(markers);
	map.fitBounds(group.getBounds());
}

function searchLocationsNear(lat, lng, name, callbackFnk, onlyMap = false) {  
  	LoaderShow();
	clearLocations();
	markers = [];
	
  // var searchUrl = 'https://seiko-sync.herokuapp.com/postrequest/'; 
  //var searchUrl = 'https://apps-jsa.com/seiko-staging-app/public/api/postrequest';
  var searchUrl = 'https://seiko-apps.com/public/api/postrequest';
  
	var _data={};
  
  if(lat && lng){    
    _data["latitude"]   = lat;
    _data["longitude"]  = lng;
     _data["name"]  = name;
   
  } else {    
     _data["storeid"]  = lng;
      	lat = _curr_lat;
		lng = _curr_lng;
     _data["name"]  = name;
  }

   $('.collections_filter_s li').removeClass('active');
  
   _curr_lat=lat;
   _curr_lng=lng;

	PostRec(searchUrl, _data, function(_err, __data){
   	    if (__data.stores.length > 0) {
   	    	var ___data = __data['stores'];
			_allstores_list=___data;
          
   	    	if(___data.length>0){
				
				map.setView([lat, lng], 13);
				$('.l_map_wrap_right').css('opacity', '1');
              
              if(onlyMap===false){
               	   var _all_strs=[];
                
                  for (var i = 0; i < ___data.length; i++) {
                      var id 			= ___data[i]._id;
                      var store_name 	= ___data[i].data.name;
                      var phone 		= ___data[i].data.phone;
                      var site 		= ___data[i].data.web;
                      var address 	= ___data[i].data.address;
                      var city_state 	= _allstores_list[i].data.city_state;
                      var latl 		= ___data[i].position[1];
                      var lngl 		= ___data[i].position[0];
                      var distance 	= getDistance(lat, lng, latl, lngl).toFixed(1);
                      var _collection =GetCollectionIcons(___data[i].collections);

                    _all_strs.push({id:id, store_name:store_name, phone:phone, address:address, city_state:city_state, latl:latl, lngl:lngl, distance:distance, i:i, collection:_collection, site:site});
                  }
                
               	 _all_strs.sort(SortStores);
                
                 for (var i = 0; i < _all_strs.length; i++) {
               		 createOption(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].city_state, _all_strs[i].latl, _all_strs[i].lngl, _all_strs[i].distance, i, _all_strs[i].collection, _all_strs[i].site); // Pass i as marker index
	         	 	createMarker(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].latl, _all_strs[i].lngl, i, _all_strs[i].distance, _all_strs[i].site, _all_strs[i].collection); // Pass i as marker index
                 }
                
                $('.current_location.mobile_new').hide();
              
				if($(window).width()>920){ 
					$(".l_map_wrap_left_scrl").mCustomScrollbar("update");
				}
              }
              else{
                $('.l_map_wrap_right').css('opacity', '.4');
              	LoaderHide();
              }
              
                if(typeof callbackFnk == 'function'){
                  callbackFnk.call();
                }
                else{
                  LoaderHide();
                }
			} else{
					searchLocationsNear(40.7394322, -73.9988017, function(){
                		PopuperShow("There are no stores near your entered location.  Please try another input address to search for locations.");
					});
			}
			
			if(markers.length){	
				centerMarkers();
			}
		}
      else {
        clearLocations();
        PopuperShow("Please search another input address to search for locations.");
      }
     });	
}

function createMobilePopup(store_name, address, phone, site, _collection, lat, lng, distance){
	return ('<div class="mob_popup"><h2>'+store_name+'</h2><h1>'+address+'</h1><p class="l_map_phone"><span><a style="text-decoration:none" href="tel:'+phone.replace(/ /g, '').replace(/-/g, '')+'">'+phone+'</a></span>'+(typeof site !='undefined' ?  (site!='' ? '<span><a target="_blank" href="'+site.toLowerCase()+'">View Website</a></span>' : ''):'')+(_collection!="" ? "<div class=\"leaf_col\">" + _collection+"</div>" : "")+'</p><a class="standard_button white border" href="https://www.google.com/maps/dir/Current+Location/'+lat+','+lng+'/" target="_blank">GET DIRECTIONS</a><p class="l_map_distance">'+distance+' mi</p><a href="#" class="popup_close mob_popup_close fr" title="close" aria-label="close shop findstore popup">close</a></div>');
}

function createOption(id, store_name, phone, address, city_state, lat, lng, distance, markerIndex, _collection, site) {	
  	$('.l_map_wrap_left_wrap').css('width', '100%');
  	
    if(window.innerWidth < 640){
      $('.store_form .standard_title').hide();
      $(".l_map_res_list").append(
          "<li class='l_map_res_list_i' tabindex='0' id='store_"+id+"' data-marker-index='"+markerIndex+"' "+
              "data-name=\""+store_name.trim()+"\" " +
              "data-address=\""+address.trim()+"\" " +
        	  "data-distance='"+distance.trim()+"' " +
        	  "data-collection='"+_collection.trim()+"' " +
              "data-phone='"+phone.trim()+"' data-storeid='listelement_"+markerIndex+"' data-ind='"+id+"' " +  
              "data-lat='"+lat+"' data-lng='"+lng+"'> " +
                  "<span class='l_map_store_name'>" + store_name.trim() + "</span>" +
                  "<p class='l_map_distance'>" + distance +" mi<span class='l_map_address'>" + city_state.trim()+"</span></p>" +
        		"<img class='map_info_img' src='https://cdn.shopify.com/s/files/1/0019/1433/9446/t/7/assets/info_map.svg?v=1594814802' />"+ 
        "</li>");
    }
  	else{
      $(".l_map_res_list").append(
          "<li class='l_map_res_list_i' tabindex='0' id='store_"+id+"' data-marker-index='"+markerIndex+"' "+
              "data-name='"+store_name.trim()+"' " +
              "data-address='"+address.trim()+"' " +
              "data-phone='"+phone.trim()+"' data-storeid='listelement_"+markerIndex+"' data-ind='"+id+"' " +  
              "data-lat='"+lat+"' data-lng='"+lng+"'> " +
                  "<span class='l_map_store_name'>" + store_name.trim() + "</span>" +
                  "<p class='l_map_distance'>" + distance +" mi</p>" +
                  "<p class='l_map_address'>" + address.trim()+"</p>" +
          "</li>");
    }
}

function createMarker(id, store_name, phone, address, lat, lng, markerIndex, distance, site, _collection) {
  lng = Number(lng.toString().replace(/,/g, ''));
  
  marker = new L.marker([lat, lng]).addTo(map);
  
  // Store the marker index in the marker object for reference
  marker.markerIndex = markerIndex;
  marker.storeId = id;
  
	marker.on("click", function (event) {
      	markerOnClick(this.markerIndex, lat, lng);
	});
	
	markers.push(marker);
	
    marker.bindPopup('<h2>'+store_name+'</h2><h1>'+address+'</h1><p class="l_map_phone"><span><a style="text-decoration:none" href="tel:'+phone.replace(/ /g, '').replace(/-/g, '')+'">'+phone+'</a></span>'+(typeof site !='undefined' ?  (site!='' ? '<span><a target="_blank" href="'+site.toLowerCase()+'">View Website</a></span>' : ''):'')+(_collection!="" ? "<div class=\"leaf_col\">" + _collection+"</div>" : "")+'</p><a class="standard_button white border" href="https://www.google.com/maps/dir/Current+Location/'+lat+','+lng+'/" target="_blank">GET DIRECTIONS</a><p class="l_map_distance">'+distance+' mi</p>', {
    	maxWidth : 600
    });
}

function markerOnClick(markerIndex, lat, lng) {
    centerLeafletMapOnMarker(lat, lng, 16);
    
	$('.l_map_res_list_i').removeClass('selected');
	$('.l_map_res_list_i[data-storeid="listelement_'+markerIndex+'"]').addClass('selected');
	$(".l_map_wrap_left_scrl").mCustomScrollbar("scrollTo", '.l_map_res_list_i[data-storeid="listelement_'+markerIndex+'"]');
}

function centerLeafletMapOnMarker(lat, lng, zoom) {
  lng = Number(lng.toString().replace(/,/g, ''));
	map.flyTo([lat, lng], zoom);
}

function get_all_addresses(_data){
  var _allpr=[];
  var _ind=0;
  _data.map(function(_k,_c){
    if(_ind<3 && (_k.display_name.indexOf(', USA')>0 || _k.display_name.indexOf(', Guam')>0 || _k.display_name.indexOf(', United States')>0 || _k.display_name==$('#praddress').val())){
      var _address=_k.display_name.replace(/, United States of America/g,'');
      if(_address.indexOf('County')>0){
        var _tmm=_address.split(',');
        var _new_addr=[];
        _tmm.map(function(_t){
          if(_t.indexOf('County')==-1) _new_addr.push(_t.trim());
        });
        _address=_new_addr.join(', ');
      }
    	_allpr.push({"id":_c+2, "title":_address, "lat":_k.lat, "lon":_k.lon});
      _ind++;
    }
  });
  return _allpr;
}

function Map_filter_result(){
		var _all_filters=[];
		
		$(".collections_filter_s li").each(function(){
			 if($(this).hasClass('active')) _all_filters.push(parseInt($(this).attr('data-id')));
		});
		
 		 $(".l_map_res_list").empty();
  
		markers.map(function(_i){
			 map.removeLayer(_i);
		 });
  
		markers = [];
  
  		var _ind=0;
  		var _all_strs=[];
  
		for (var i = 0; i < _allstores_list.length; i++) {
			var _filters=(_allstores_list[i].collections || []);
			var _showitem=false;
			if(_all_filters.length>0 && _filters.length>0){
				var _sovpcount=0;
				for (var j = 0; j < _all_filters.length; j++) {
					if(_filters.indexOf(_all_filters[j])>-1){
						_sovpcount++;
						if(_sovpcount==_all_filters.length){
							_showitem=true;
							break;
						}
					}
				}
			} else if(_all_filters.length==0){
				_showitem=true;
			}

			if(_showitem){
				var id 			= _allstores_list[i]._id;
					var store_name 	= _allstores_list[i].data.name;
					var phone 		= _allstores_list[i].data.phone;
                  	var site 		= _allstores_list[i].data.web;
					var address 	= _allstores_list[i].data.address;
              		var city_state 	= _allstores_list[i].data.city_state;
					var latl 		= _allstores_list[i].position[1];
					var lngl 		= _allstores_list[i].position[0];
					var distance 	= getDistance(_curr_lat, _curr_lng, latl, lngl).toFixed(1);
                  	var _collection =GetCollectionIcons(_allstores_list[i].collections);
              
              		_all_strs.push({id:id, store_name:store_name, phone:phone, address:address, city_state:city_state, latl:latl, lngl:lngl, distance:distance, i:_ind, collection:_collection, site:site});
                  _ind++;
			}
		}
  
  		_all_strs.sort(SortStores);
                
        for (var i = 0; i < _all_strs.length; i++) {
          createOption(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].city_state, _all_strs[i].latl, _all_strs[i].lngl, _all_strs[i].distance, i, _all_strs[i].collection, _all_strs[i].site); // Pass i as marker index
          createMarker(_all_strs[i].id, _all_strs[i].store_name, _all_strs[i].phone, _all_strs[i].address, _all_strs[i].latl, _all_strs[i].lngl, i, _all_strs[i].distance, _all_strs[i].site, _all_strs[i].collection); // Pass i as marker index
        }

		if(markers.length>0){
          	centerMarkers();
		}
		$(".l_map_wrap_left_scrl").mCustomScrollbar("update");
	}

$(document).ready(function(e) {
  
    if($('.store_form').length){
      if(!$('.l_map_res_list_i').length){
		$('.store_form .standard_title').show();
      }
      else{
      	$('.current_location.mobile_new').hide();
      }
    }
    
    $('.collections_filter_s li').on('click', function(){
      if($(this).hasClass('active')){
          $(this).removeClass('active');
      } else {
         $(this).addClass('active');
      }
      	Map_filter_result();
    });
    
    $('.current_location').on('click keypress', function(){
           	$(".l_map_res_list").empty();
        	L_GeoIP();
      });

	$('#praddress').keypress(function (e) {
	  if (e.which == 13) {
		// searchLocations(); 
	  }
	});		

	$("body").on('click', '.address_search', function(e) {
		e.preventDefault(); 
		searchLocations(); 
	});

	$('body').on('click', '.l_map_wrap_o, .l_map_wrap_close', function(e) {
		e.preventDefault();
		$('.l_map_wrap_modal').css({'opacity':'0','visibility':'hidden'});
		return false;
	});

	if($(".l_map_wrap_left_scrl").length){
		$(".l_map_wrap_left_scrl").mCustomScrollbar({
			axis:"y",
			theme:"dark"
		});
	}
    
  let typingTimer;
const doneTypingInterval = 500; // 0.5 seconds

$("#praddress").on('keyup', function () {
    clearTimeout(typingTimer);

    typingTimer = setTimeout(function () {
        var _data = $("#praddress").val();
        const selectedValue = $('input[name="search_type"]:checked').val();

        if (_data.length > 2) {
            PostRec('https://geocode.maps.co/search?q=' + _data + '&countrycodes=us&format=json&api_key=658c72e030653798329319cwx861442', _data, function (_err, ___data) {
                if (selectedValue == 'location') {
                    var addresses_drop = (___data ? get_all_addresses(___data) : []);
                    $('.addresses_drop').html('');
                    if (addresses_drop.length) {
                        for (var _a = 0; _a < addresses_drop.length; _a++) {
                            $('.store_form').addClass('opened');
                            $('.addresses_drop').addClass('opened').append(
                                "<li class='l_drop_li' data-id='" + addresses_drop[_a]['id'] + "' " +
                                "data-name='" + addresses_drop[_a]['title'].trim() + "' " +
                                "data-address='" + addresses_drop[_a]['title'].trim() + "' " +
                                "data-lat='" + addresses_drop[_a]['lat'] + "' data-lng='" + addresses_drop[_a]['lon'] + "'>" +
                                addresses_drop[_a]['title'] + "</li>"
                            );
                        }
                    } else {
                        $('.store_form').addClass('opened');
                        $('.addresses_drop').addClass('opened').append("<li>No address found.</li>");
                    }
                } else if (selectedValue === 'name') {
                    $('.store_form').addClass('opened');
                    searchLocationsNear("", "", _data);
                }
            });
        }
    }, doneTypingInterval);
});

$("#praddress").on('keydown', function () {
    clearTimeout(typingTimer);
});
    
    $('body').on('click keypress', '.mob_popup_close', function(e) {
      $('.mobile_pin_popup').html('').hide();
      $('body').css('overflow', 'inherit');
    });

	$('body').on('click keypress', '.l_map_res_list_i', function(e) {

        if($(e.target).attr('class') == 'map_info_img'){
          e.preventDefault();
          $('html, body').animate({
            scrollTop: 0
          });
          var mobile_pin_popup_info = createMobilePopup($(this).attr('data-name'), $(this).attr('data-address'), $(this).attr('data-phone'), $(this).attr('data-site'), $(this).attr('data-collection'), $(this).attr('data-lat'), $(this).attr('data-lng'), $(this).attr('data-distance'));
          $('.mobile_pin_popup').css('height', window.innerHeight-54).html(mobile_pin_popup_info).show();
          $('body').css('overflow', 'hidden');
          $('.l_map_res_list_i').removeClass('selected');
          $(this).addClass('selected');
        }
        else{
          // Use data-marker-index instead of data-id for correct marker reference
          var markerIndex = parseInt($(this).attr('data-marker-index'));
          if (markers[markerIndex]) {
              markers[markerIndex].openPopup();
              $('.leaflet-marker-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon.png');
              $('.leaflet-marker-icon').eq(markerIndex).attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon-black.png');
              $('.l_map_res_list_i').removeClass('selected');
              $(this).addClass('selected');	
              centerLeafletMapOnMarker($(this).attr('data-lat'), $(this).attr('data-lng'), 16);
              if(window.innerWidth < 640){
                 $('html, body').animate({
                   scrollTop: ($(".l_map_wrap_right").offset().top-100)
                 }, 2000);
              }
          }
        }
	});

  	$('body').on('click', '.l_drop_li', function(e) {
      	$('.store_form').removeClass('opened');
      	$('.addresses_drop').removeClass('opened').html('');
      	$('#praddress').val($(this).data('address'));
     	 searchLocationsNear(parseFloat($(this).data('lat')),parseFloat($(this).data('lng')));
	});
  
  	$('body').on('click', '.store_form.opened .form_block button.close_search', function(e){
      	e.preventDefault();
  		$('.store_form').removeClass('opened');
      	$('.addresses_drop').removeClass('opened').html('');
      return false;
  	});
  
  	$('body').on('click', '.leaflet-marker-icon', function(e){
		$('.leaflet-marker-icon').attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon.png');
  		$(this).attr('src', 'https://cdn.shopify.com/s/files/1/0242/8164/5108/t/1/assets/marker-icon-black.png');
  	});
  
  	if($('#mapid').length || $('#mapid_mobile').length){
  
      token = 'pk.eyJ1IjoiYXJha3MiLCJhIjoiY2prdXVid21mMGl3YjN2cW5oNjV0b2hyZSJ9.ruwlUiU1KHzzL7jCLgJxnA';
      if(window.innerWidth > 640){
      	map = L.map('mapid');
      }
      else{
      	map = L.map('mapid_mobile');
      }

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
         maxZoom: 18,
         attribution: 'Map data &copy; '
      }).addTo(map);

      var _hashed=window.location.hash.replace('#','').trim();
      var _hashelements=_hashed.split("|");
      
      if(_hashelements.length==3){
        $('.list_loader_popup').show();
       
         _curr_lat=_hashelements[1];
		 _curr_lng=_hashelements[2];
        
        setTimeout(function(){ 
            searchLocationsNear(_curr_lat, _curr_lng, function(){
              if($('#store_'+_hashelements[0])[0]) 
               $('#store_'+_hashelements[0]).trigger('click');
            });
        }, 100);
        
        setTimeout(function(){ 
        	$('.list_loader_popup').hide();
        }, 2500);
      } else {
        $('.list_loader_popup').hide();
      	setTimeout(function(){ L_GeoIPFirstOpen(); },100);
      }
    }
});

////////////////////////////////////////////////////////////////////////////////
function SortStores( a, b ) {
  if ( parseFloat(a.distance) < parseFloat(b.distance) ){
    return -1;
  }
  if ( parseFloat(a.distance) > parseFloat(b.distance) ){
    return 1;
  }
  return 0;
}

// PostRec function - add this if it's missing from your code
function PostRec(url, data, callback) {
    $.ajax({
        url: url,
        type: 'POST',
        data: JSON.stringify(data),
        contentType: 'application/json',
        success: function(response) {
            callback(null, response);
        },
        error: function(xhr, status, error) {
            callback(error, null);
        }
    });
}